import { RequestCharge } from "./request-charge";
import { RequestVenueFacility } from "./request-venue-facility";
import { RequestHistory } from "./request-history";

export class RequestVenue {
  id: number;
  requestId: number;
  companyId: number;
  companyName: string;
  requestNumber: string;
  requestDate: Date;
  requestTypeId: number;
  requestTypeName: string;
  requestStatusId: number;
  requestStatusName: string;
  requestorId: number;
  requestorName: string;
  onBehalfId: number;
  onBehalfName: string;
  remarks: string;

  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  phone: string;

  venueId: number;
  venueName: string;
  venueTypeName: string;
  venueCapacity: number;
  venueLayoutId: number;
  venueLayoutName: string;

  meetingDate: Date;
  meetingToDate: Date;
  meetingTitle: string;
  meetingDescription: string;
  startTimeHours: number;
  startTimeMinutes: number;
  startTimeSymbol: string;
  endTimeHours: number;
  endTimeMinutes: number;
  endTimeSymbol: string;
  specialServicesIds: string[];
  requestCharges: RequestCharge[];
  specialServices: RequestVenueFacility[];
  otherFacilityType: string;


  startTimeFullString: string;
  //get startTimeFullString() {
  //  return this.startTimeHours.toString() + ':' + this.formatMinutes(this.startTimeMinutes) + ' ' + this.startTimeSymbol
  //}
  //set startTimeFullString(value: string) {
  //  this._startTimeFullString = value;
  //}

  endTimeFullString: string;
  //get endTimeFullString() {
  //  return this.endTimeHours.toString() + ':' + this.formatMinutes(this.endTimeMinutes) + ' ' + this.endTimeSymbol
  //}
  //set endTimeFullString(value: string) {
  //  this._endTimeFullString = value;
  //}

  private formatMinutes(minutesVal: number): string {
    if (!isNaN(minutesVal) && minutesVal >= 0 && minutesVal < 10)
      return "0" + minutesVal.toString();
    else
      return minutesVal.toString();
  }

  userCanEditRequest: boolean;
  userCanCancelRequest: boolean;
  isMeetingExpired: boolean;

  facilityTypes: number[];

  finalApprovalHistory: RequestHistory;

  roomChargeType: string;
  roomChargeAmount: string;

  userCanFeedback: boolean;
}




// WEBPACK FOOTER //
// ./src/app/core/models/request-venue.ts